const AlertEventsTypes = {
  SET_ALERT_EVENTS: "alertFactory/alertEvents/SET_ALERT_EVENTS",
  SET_ALERT_EVENTS_FILTERS: "alertFactory/alertEvents/SET_ALERT_EVENTS_FILTERS",
  SET_ALERT_EVENTS_PAGE: "alertFactory/alertEvents/SET_ALERT_EVENTS_PAGE",
  SET_ALERT_EVENTS_LIMIT: "alertFactory/alertEvents/SET_ALERT_EVENTS_LIMIT",
  SET_ALERT_EVENTS_INITIALIZED:
    "alertFactory/alertEvents/SET_ALERT_EVENTS_INITIALIZED",
};

export default AlertEventsTypes;
